export default {
    getCurrentTime() {
        return +new Date();
    },
    getPropertyName(data, name) {
        if (data && name && data[name]) {
            if (Array.isArray(data[name]) && data[name] instanceof Object) {
                return Object.getOwnPropertyNames(data[name][0]);
            }
        }
        return null;
    },
    formatObj(data) {
        var tmp = JSON.stringify(data);
        tmp = JSON.parse(tmp);
        for (let item in tmp) {
            try {
                tmp[item] = JSON.parse(tmp[item]);
            } catch (e) {
                console.log('大屏幕' + item + '--数据格式不是json');
                tmp[item] = null;
            }
        }
        return tmp;
    }
};


// WEBPACK FOOTER //
// ./src/tool/index.js